// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_5sm","cls2":"LoggedInDiscoveryPage-cls2_S45 LoggedInDiscoveryPage-cls1_5sm"};